<template>
    <footer style="width: 100%;top: 0px;">
        © 2024 Copyright - Les - Refuges
    </footer>
</template>
<style src="../assets/css/header.css"></style>